import * as XLSX from 'xlsx'
import { reactive } from '@vue/composition-api'
import { useAggregationResultTable } from '@/views/v2-temp/report/aggregation-container/composables/useAggregationResultTable'
import type { DisplayMode } from '@/views/v2-temp/report/aggregation-container/composables/useAggregationResultTable'

export interface AggregationMeta {
  uid: string // ハッシュ化されたID
  sheetName: string
}

// IDをハッシュ化する関数（ソルト付き）
export const hashId = (id: number, salt: string): string => {
  return btoa(`${id}_${salt}`).substring(0, 12)
}

export const sanitizeSheetName = (name: string): string => name.replace(/[:\\/?*[\]]/g, '_').slice(0, 31)

export const buildWorksheetFromAggregation = (aggregation: any) => {
  const props = reactive({
    aggregation,
    loading: false,
    displayMode: 'sum' as DisplayMode,
    today: '',
  })
  const { aggregationTable } = useAggregationResultTable(props, null)
  const table = aggregationTable.value()
  const { headers } = table
  const rows = table.items.map((item: any) => headers.map(h => item[h.value]))
  rows.unshift(headers.map(h => h.text))

  return XLSX.utils.aoa_to_sheet(rows)
}

// メタデータシートを作成する関数
export const createMetaSheet = (metaData: AggregationMeta[]) => {
  const headers = ['UID', 'シート名']
  const rows = metaData.map(item => [item.uid, item.sheetName])
  rows.unshift(headers)

  return XLSX.utils.aoa_to_sheet(rows)
}

// 重複を考慮したシート名を生成する関数
export const generateUniqueSheetName = (baseName: string, existingNames: string[]): string => {
  let sheetName = sanitizeSheetName(baseName)
  let counter = 1
  const originalName = sheetName

  while (existingNames.includes(sheetName)) {
    sheetName = `${originalName}_${counter}`
    counter += 1
  }

  return sheetName
}
